<script>
import clientService from '../services/clients';
import {getPaginatedItems, getPaginatedItems2} from '../utils/index.js';
export default {
   name: "DataTable",
   data() {
      return {
         configs: {
            orderBy: 'nome',
            order: '',
            filter: '',
         },
         filterIsActive: false,
         header: [{
            title: 'nome',
            alias:'nome'
         }, {
            title:'telefone',
            alias:'fone1'
         }, {
            title: 'email',
            alias: 'email'
         }],
         
         data: '',
         paginate: ['clients'],
         clientSelected : {},
         currentPage: 1,  
      }
   },
   computed: {
      list() {
         const filter = this.configs.filter;
         const list = _.orderBy(this.data, this.configs.orderBy, this.configs.order);

         if (_.isEmpty(filter)) {
               return list
         }else{
            const filteredList = _.filter(list, client =>_.deburr(client.nome.toLowerCase()).indexOf(_.deburr(filter.toLowerCase())) >= 0);
            if (filteredList.length == 0) {
               filteredList.push({nome: 'Nenhum cliente encontrado', fone1: '', email: ''});
            }
            return filteredList;
         }
      }
   },
   methods: {
      showInfo: function(client) {
         this.$bus.$emit('showClient', client);
         this.clientSelected = client;
      },
      sort(orderBy){
         this.configs.orderBy = orderBy;
      },
   },
   mounted() {
      clientService.getAll().then(response => response.data)
         .then(data => {
            this.$set(this, 'data', data.clientes);
            this.$store.commit("CLIENTS_SET_LIST", { client: data.clientes });
            // se retornou do cadastro do cliente com o id, preenhe o campo do filtro e seleciona o cliente na tabela
            if (window.location.hash != '') {
               const id = window.location.hash.replace('#', '');
               const clientInfo = data.clientes.filter( (c) => c.id == id )[0];
               this.configs.filter = clientInfo.nome;
               this.showInfo(clientInfo);
            }
         })
   },
}
</script>
<template>
<div class="">
   <div class="p-input field" :class="{active: filterIsActive}">
      <label for="528" class="label">
         <span>Filtrar</span>
      </label>
      <div class="inner">
         <input autocomplete="off" v-model="configs.filter" class="input" type="text" @focus="filterIsActive = true" @blur="filterIsActive = false">
      </div>
   </div>
   <div class="p-table">
      <table class="table">
         <thead>
            <tr>
               <th v-for="e in header" @click="sort(e.alias)" scope="col">{{e.title}}</th>
            </tr>
         </thead>
         <paginate ref="paginator"
         name="clients"
         :list="list"
         tag="tbody"
         :per="10">
            <tr v-for="p in paginated('clients')" @click="showInfo(p)" v-bind:class="{selected : clientSelected == p}">
               <td> {{p.nome}} </td>
               <td> {{p.fone1 || '-'}} </td>
               <td> {{p.email || '-'}} </td>
            </tr>
         </paginate>
      </table>
      
   </div>
   <paginate-links
   for="clients"   
   :limit="5"
   :show-step-links="true"
   class="d-flex p-pagination">
   </paginate-links>
</div>
</template>
<style lang="scss">
   .selected td {
      background-color: rgb(243, 243, 243);
   }
</style>


// WEBPACK FOOTER //
// src/js/components/p-data-table.vue